export default "__VITE_ASSET__Btck7UkM__"